<template>
  <span class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clip-path="url(#clip0_13423_57436)">
        <path
          d="M11.9997 6.66658L21.333 15.9999L11.9997 25.3332"
          stroke="#333333"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13423_57436">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </span>
</template>
